import { render } from "./Rune.vue?vue&type=template&id=5b6dc0e6&scoped=true"
import script from "./Rune.vue?vue&type=script&lang=ts"
export * from "./Rune.vue?vue&type=script&lang=ts"

import "./Rune.vue?vue&type=style&index=0&id=5b6dc0e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b6dc0e6"

export default script